<template>
  <div style="position: relative">
    <div class="message" v-if="showMap">
      <div class="message-error" v-if="msgErro">
        <i class="fa fa-warning"></i> {{msgErro}}
      </div>
      <div class="message-info" v-else>Clique no mapa para alterar o local</div>
    </div>

    <div class="map-container" v-if="center">
      <l-map
          :zoom="zoom"
          :center="center"
          :options="mapOptions"
          @click="centerUpdate"
          @leaflet:load="isMapLoad"
          @ready="mapReady">
        <l-tile-layer :url="url" :attribution="attribution"/>
        <l-marker :lat-lng="empresa" v-if="empresa">
          <l-icon :icon-anchor="[24, 24]" :icon-size="[48, 48]" :icon-url="require('../../assets/icons/restaurant-icon.png')"/>
          <l-tooltip :options="{ offset: [0, -24], direction: 'top' }">Sua empresa está aqui</l-tooltip>
        </l-marker>
        <l-marker :lat-lng="userLocation" v-if="userLocation">
          <l-icon :icon-size="[48, 48]" :icon-anchor="[24, 24]" :icon-url="require('../../assets/icons/pin-icon.png')"/>
          <l-tooltip :options="{ offset: [0, -24], direction: 'top' }">O cliente está aqui</l-tooltip>
        </l-marker>
        <l-circle :lat-lng="empresa" :radius="raio_empresa" :weight="4" :fillOpacity="0.001" v-if="empresa && raio_empresa"/>
      </l-map>
    </div>
    <div v-if="!showMap" class="mt-5">
      <loading fullscrean="true" text="Carregando mapa"/>
    </div>
  </div>
</template>

<script>
  import { latLng, Icon } from "leaflet";
  import { LMap, LTileLayer, LMarker, LPopup, LTooltip , LControl, LIcon, LCircle } from "vue2-leaflet";
  import Loading from "../../components/commons/Loading";

  delete Icon.Default.prototype._getIconUrl;
  Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });

  export default {
    name: "MapPedido",
    components: {Loading, LMap, LTileLayer, LMarker, LPopup, LTooltip, LControl, LIcon, LCircle },
    props: ['dados'],

    data() {
      return {
        map: null,
        showMap: false,
        zoom: 18,

        msgErro: '',
        userLocation: null,
        center: null,
        empresa: null,
        raio_empresa: null,

        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        mapOptions: { zoomSnap: 0.5, minZoom: 12, maxZoom: 18, zoomControl: true },
        circle: null
      };
    },

    methods: {
      isMapLoad() {
        this.showMap = true;
      },

      centerUpdate(center) {
        if (center && center.latlng) {
          this.userLocation = center.latlng;
          this.validarDistancia();
        }
      },

      validarDistancia() {
        if (!this.map) {
          return false;
        }

        const distance = this.map.distance(this.empresa, this.userLocation);

        if (this.raio_empresa && distance > this.raio_empresa) {
          this.msgErro = "Infelizmente não entregamos aqui!";
          return false;

        } else {
          this.msgErro = "";
          return true;
        }
      },

      confirmar() {
        if (!this.validarDistancia()) {
          this.$swal("Esta localização está fora da área de entregas da empresa")
          return;
        }

        this.$emit('editarDados', this.userLocation);
        this.remove();
      },

      mapReady(m) {
        this.map = m;
        this.validarDistancia();
      },

      remove() {
        this.center = null;
        this.showMap = false;
      },

      openMapa(endereco) {
        if (!endereco || !this.dados.lat_empresa || !this.dados.long_empresa) {
          this.remove();
          return;
        }

        this.msgErro = "";
        this.center = null;
        this.showMap = false;

        setTimeout(() => {
          this.showMap = true;
          const local = latLng(endereco.lat_endereco, endereco.long_endereco);
          this.empresa = latLng(this.dados.lat_empresa, this.dados.long_empresa);
          this.zoom = endereco.buscar_mapa ? parseInt(this.dados.raio_cidade || 12000) >= 12000 ? 13 : 14.5 : 16;

          if (this.dados.geo_disabled === '0') {
            this.raio_empresa = parseInt(this.dados.raio_empresa);
          }

          if (local) {
            this.userLocation = local;
            this.center = local;
          }

          this.validarDistancia();
        }, 500);
      }
    }
  };
</script>
<style>
  .message {
    position: absolute;
    bottom: 22px;
    left: 50%;
    z-index: 99999;
    transform: translateX(-50%);
    max-width: 600px;
    color: #fff;
    text-align: center;
  }

  .message .message-error {
    padding: 12px 20px;
    background-color: var(--secondary);
    border-radius: 8px;
  }

  .message .message-info {
    padding: 12px 20px;
    background-color: rgba(100, 149, 255, 0.8);
    border-radius: 8px;
  }

  .map-container a:hover {
    text-decoration: none;
  }

  .map-container {
    height: calc(100vh - 165px);
  }

  @media (max-width: 767px) {
    .map-container {
      height: calc(100vh - 72px);
    }
  }
</style>
